import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@recruitee/i18n';
import { AssignedLocationsInfoContainerComponent } from '@recruitee/locations';
import type { OfferStatus } from '@recruitee/offers-types';
import { OfferStatusComponent } from '@recruitee/offers-ui';
import {
  BadgeComponent,
  BoxComponent,
  ButtonComponent,
  ClickToCopyDirective,
  DateComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
} from '@recruitee/user-interface';

export type RequisitionsJobItem = {
  id: number;
  guid: string;
  status: OfferStatus;
  title: string;
  url: string;
  department: string | null;
  location: string;
  locationIds?: number[];
  lastActivityAt: string;
  qualifiedCount: number;
  hiredCount: number;
  disqualifiedCount: number;
};

@Component({
  selector: 'rt-requisitions-job-item',
  templateUrl: './requisitions-job-item.component.html',
  styleUrls: ['./requisitions-job-item.component.less'],
  imports: [
    BadgeComponent,
    BoxComponent,
    ClickToCopyDirective,
    CommonModule,
    DateComponent,
    DividerComponent,
    HeadingComponent,
    IconComponent,
    OfferStatusComponent,
    RouterModule,
    RtTooltip,
    TranslatePipe,
    ButtonComponent,
    AssignedLocationsInfoContainerComponent,
  ],
})
export class RequisitionsJobItemComponent {
  @Input() public item: RequisitionsJobItem;

  public departmentLabelTooltipEnabled = false;

  @ViewChild('departmentRef') public set departmentRef(departmentRef: ElementRef) {
    if (departmentRef) this.setDepartmentTooltipEnabled(departmentRef);
  }

  constructor(private cdRef: ChangeDetectorRef) {}

  private setDepartmentTooltipEnabled(departmentRef: ElementRef) {
    this.departmentLabelTooltipEnabled =
      departmentRef.nativeElement.offsetWidth < departmentRef.nativeElement.scrollWidth;
    this.cdRef.detectChanges();
  }
}
